module.exports = __webpack_public_path__ + "assets/img/news (38).c695429c.png";